import { ReduxState, ReferralInfo, Wallet } from '../../interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { FC, useEffect, useState } from 'react';
import { WalletSummary } from '../wallet/walletSummary/walletSummary';
import { getWallet } from '../wallet/wallet.service';
import ProfileVerify from '../profile/verify/verify.index';
import { Card } from '../../utilities/components';
import { FaAngleLeft } from 'react-icons/fa';
import Banner from '../../assets/referral/Banner.png';
import { Button } from '../components';
import { TbCopy } from 'react-icons/tb';
import { copyToClipboard, hasFirstTimeVideoSeen } from '../../scripts';
import { getReferralInfo } from '../referral/referral.service';
import ConvertBox from '../trade/convertBox/convertBox.index';
import { Markets } from '../markets/markets.index';
import Reports, { ReportType } from '../reports/reports.index';
import { Link } from 'react-router-dom';

interface OwnProps {}

type Props = OwnProps & ConnectedProps<typeof connector>;

const Dashboard: FC<Props> = (props) => {
    const [wallet, setWallet] = useState<Wallet>();
    const [walletLoading, setWalletLoading] = useState<boolean>(false);
    const [hideBalances, setHideBalances] = useState<boolean>(false);

    const [referralInfo, setReferralInfo] = useState<ReferralInfo>();
    const [referralInfoLoading, setReferralInfoLoading] = useState<boolean>(false);
    const [isFirstTimeVideoOpen, setIsFirstTimeVideoOpen] = useState<boolean>(false);

    useEffect(() => {
        getWallet(setWalletLoading, setWallet);
        getReferralInfo(setReferralInfoLoading, setReferralInfo);
        if (hasFirstTimeVideoSeen.get()) {
            setIsFirstTimeVideoOpen(false);
        } else {
            setIsFirstTimeVideoOpen(true);
            hasFirstTimeVideoSeen.set(true);
        }
    }, []);

    return (
        <div className={'flex flex-col p-6'}>
            {/* <YaldaModal /> */}
            {/*<BlackFridayModal />*/}
            {/* <FirstTimeVideoModal
                title="ویدیو معرفی"
                src="http://new.30pay.me/media/firstTime-video.mp4"
                description="  در این ویدیو با نحوه کار با وبسایت ۳۰پی آشنا می‌شوید."
                isOpen={isFirstTimeVideoOpen}
                onClose={() => setIsFirstTimeVideoOpen(false)}
            /> */}
            <div className={'flex gap-6 max-lg:flex-col'}>
                <div className={'flex flex-col gap-6 flex-[0.66]'}>
                    <WalletSummary wallet={wallet} hideBalances={hideBalances} setHideBalances={setHideBalances} />
                    <div className={'flex gap-6 max-lg:flex-col'}>
                        <ProfileVerify isPreview className={'flex flex-[0.66] !mt-0'} />
                        <Card size={'small'} className={'flex-[0.34]'}>
                            <div className={'flex flex-col justify-between h-full'}>
                                <div className={'flex items-center justify-between'}>
                                    <span className={'font-bold text-base text-darkPurple-100'}>شناسایی دو عاملی</span>
                                    <Link
                                        to={'/security'}
                                        className={
                                            'flex items-center justify-center w-6 h-6 hover:bg-primary-20 rounded transition duration-300 ease-in-out'
                                        }
                                    >
                                        <FaAngleLeft size={16} className={'text-primary-100'} />
                                    </Link>
                                </div>
                                {props.user?.twoFactor.isActive ? (
                                    <div
                                        className={`py-1 px-3 font-bold text-xs rounded-[30px] w-fit max-lg:mt-2 border-[3px] text-white bg-positive-dark border-positive-light`}
                                    >
                                        فعال شده
                                    </div>
                                ) : (
                                    <Link
                                        to={'/security'}
                                        className={
                                            'mt-1 font-bold text-base text-primary-100 transition ease-in-out duration-300'
                                        }
                                    >
                                        فعالسازی
                                    </Link>
                                )}
                            </div>
                        </Card>
                    </div>
                </div>
                <Card
                    size={'small'}
                    title={'دعوت از دوستان'}
                    url={'/referral'}
                    titleDivider
                    loading={referralInfoLoading}
                    className={'flex-[0.34]'}
                >
                    <img src={Banner} alt={'Banner'} className={'w-full rounded-lg max-h-[159px] object-cover'} />
                    <div
                        className={
                            'flex justify-between items-center pl-2 pr-4 h-12 rounded-[28px] border border-primary-20 mt-4'
                        }
                    >
                        <span className={'font-bold text-sm text-black-100'}>کد دعوت</span>
                        <span className={'font-semibold text-base text-black-100 en'}>{referralInfo?.code}</span>
                        <Button
                            type={'primary'}
                            icon={<TbCopy />}
                            className={'!h-8 rounded-[32px] max-lg:hidden'}
                            onClick={() => copyToClipboard(referralInfo?.code, 'کد دعوت')}
                        >
                            کپی
                        </Button>
                        <Button
                            type={'primary'}
                            icon={<TbCopy />}
                            className={'!h-8 !min-w-8 rounded-[32px] lg:hidden'}
                            onClick={() => copyToClipboard(referralInfo?.code, 'کد دعوت')}
                        />
                    </div>
                </Card>
            </div>
            <div className={'flex mt-6 gap-6 max-lg:flex-col lg:max-h-[500px] lg:overflow-hidden'}>
                <ConvertBox isPreview title={'معامله آسان'} />
                <Card
                    size={'small'}
                    title={'قیمت لحظه ای'}
                    url={'/markets'}
                    titleDivider
                    noPadding
                    noBottomPadding
                    className={'flex-[0.578] overflow-auto'}
                >
                    <Markets isPreview />
                </Card>
            </div>
            <Card size={'small'} url={'/reports'} className={'mt-6'} title={'گزارشات اخیر'} noPadding>
                <Reports type={ReportType.Transaction} />
            </Card>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(Dashboard);
